import React, { useEffect, useState } from 'react';
import { CheckoutProvider } from '@stripe/react-stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from '../components/CheckoutForm'
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import { mode } from 'crypto-js';
import { useLocation } from "react-router-dom";
import { GetProductById } from '../Functions'



const stripePromise = loadStripe('pk_test_51QX1rwGGgItIZYPesDn4I2u9f3QliSCD6JtA02bOrmfPJVqgQsGTdilf4oTm1rmKXssh6PYZlN3WoJREz5iK2zZj00rqvFnSOE');
const backendUrl = 'https://yxwperpdda.execute-api.eu-central-1.amazonaws.com/default/giftboxstripecheckout?action=Checkout';


const Checkout = () => {

    const [product, setProduct] = useState([])
    const [amount, setAmount] = useState(0)



    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const serviceId = queryParams.get("sid");
    const productId = queryParams.get("pid");
    const producamount = queryParams.get("productamount");

    const [clientSecret, setClientSecret] = useState(null);

    const fetchClientSecret = async () => {
        try {

            const response = await fetch(backendUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ amount: amount }),
            });

            console.log("calling client secret : ", amount)

            const data = await response.json();
            const fetchedClientSecret = data.Response.clientSecret;

            if (fetchedClientSecret) {
                setClientSecret(fetchedClientSecret);  // Store clientSecret in state
            } else {
                console.error("Failed to retrieve client secret");
            }
        } catch (error) {
            console.error("Error fetching client secret:", error);
        }
    };


    useEffect(async () => {
        const prod = await GetProductById(serviceId, productId)
        setProduct(prod)
        console.log(prod)
        if (producamount) {
            setAmount(producamount)
        } else {
            setAmount(prod.prices.retail.amount)
        }

        fetchClientSecret();
    }, []);  

    if (!clientSecret) {
        return <Loader />;  
    }


    return (
        <div className='mt-8'>
            <Navbar />

            <div className='container' style={{ marginTop: '100px' }}>
                <div className='row' >


                    <div className='col-md-5 order-md-1 order-3' >
                        <h2 mb-3>Checkout</h2>
                        <Elements stripe={stripePromise} options={{ clientSecret }}>
                            <CheckoutForm product={product} amount={amount} />
                        </Elements>
                    </div>

                    <div className='col-md-2 order-2' >
                        <div className='divider'></div>
                    </div>

                    <div className='col-md-4 order-md-3 order-1' >

                        <div className='d-flex flex-row gap-5 mb-4' >
                            <div className="checkout-img">
                                <img className='br_5 ' src={product?.image} />

                            </div>

                            <div className='d-flex flex-column'  >
                                <div>
                                    <p className="text-dark bold">{product?.name}</p>
                                    <p className='text-dark' >{product.description}</p>
                                </div>

                                {product.validity ?
                                    <p className="text-dark">
                                        <span className="bold">Validity: </span>
                                        {product.validity.quantity} {product.validity.unit}
                                    </p> : ""}


                                <p className="bold text-dark">${amount}</p>




                            </div>
                        </div>

                    </div>


                </div>

            </div>

            <Footer />
        </div >
    )
};

export default Checkout;